<template>
  <div v-if="islabel" :class="['tol-button', 'tol-button-' + buttonType, { disabled }]">
    <div class="show-label">
      <span>
        <font-awesome-icon :icon="iconName" />
        {{ label }}
      </span>
    </div>
  </div>
  <div
    v-else
    :class="[
      'tol-button',
      'tol-button-' + buttonType,
      { disabled },
      label && iconName && 'label-with-icon'
    ]"
    @click="$emit('click')"
    @mouseover="showTooltip = true"
    @mouseout="showTooltip = false"
  >
    <vue-simple-spinner v-if="isLoading" size="small" />
    <div v-show="tooltip && showTooltip" class="tooltip">{{ tooltip }}</div>
    <div class="icon">
      <font-awesome-icon v-if="iconName" :icon="iconName" />
    </div>
    <div class="button-label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  name: 'TolButton',
  props: {
    label: {
      type: String,
      default: ''
    },
    buttonType: {
      type: String,
      required: true
    },
    iconName: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    },
    islabel: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showTooltip: false
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';

.tol-button {
  white-space: nowrap;
  cursor: pointer;
  .icon {
    display: inline-block;
    margin-right: 8px;
  }
  .button-label {
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
  }
}

.tol-button-major {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $blue;
  color: $white;
  height: 60px;
  width: 250px;
  text-align: center;
  &.disabled {
    background-color: $mid-grey-2;
    color: $black;
  }
}
.tol-button-minor {
  display: inline-block;
  padding: 5px;
  position: relative;
  &.label-with-icon {
    display: flex;
    align-items: center;

    .icon {
      min-width: 100%;
    }
  }

  .button-label {
    color: $text-color-dark;
  }
  &.assignment-action.disabled,
  &.contractor-save.disabled {
    .button-label {
      color: $dark-grey-1;
    }
  }
  &.assignment-action,
  &.contractor-save {
    color: $white;
  }
  .icon {
    width: 100%;
    text-align: center;
    svg {
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .show-label {
    display: flex;
    width: 150px;
    background-color: $green;
    height: 35px;
    line-height: 35px;
    border-radius: 28px;
    justify-content: center;

    &:hover {
      background-color: $secondary-green;
    }
    span {
      font-weight: bold;
      color: $white;
    }
  }
}

.tooltip {
  background-color: $black;
  color: $white;
  padding: 5px 3px;
  font-size: 0.5em;
  text-transform: uppercase;
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translate(-50%, 0);
}

.action-round {
  width: 50px;
  height: 50px;
  padding: 0;
  font-size: 1.5em;
  margin-right: 20px;
  color: $white;
  border-radius: 100%;
  background-color: $light-grey-2;
  &:hover {
    background-color: $secondary-green;
  }
  &.m {
    width: 35px;
    height: 35px;
    font-size: 1em;
  }
}

@media only screen and (max-width: 768px) {
  .tol-button-major {
    width: 150px;
    height: 40px;
  }
}

@media only screen and (max-width: 375px) {
  .tol-button-major {
    width: 70px;
    height: 40px;
    //justify-content: center;
    .button-label {
      display: none;
    }

    .icon {
      margin: 0;
    }
  }
}

@media print {
  .tol-button,
  .tol-button-major,
  .tol-button-minor {
    display: none;
  }
}
</style>
